import React from 'react';
import { VarPanelConfig } from './VarPanelConfig';
import { VarPanelB } from './VarPanelB';
import { VarPanelResults } from './VarPanelResults';

export const VariantGenerator: React.FC = () => {
  return (
    <main style={{ display: 'grid', gridTemplateColumns: 'var(--panel-a) var(--panel-b) 1fr', minHeight: 0, overflow: 'hidden', flex: 1, width: '100%' }}>
      <VarPanelConfig />
      <VarPanelB />
      <VarPanelResults />
    </main>
  );
};
